// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_GetrecebimentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for getRecebimentos() — GET /recebimentos/getRecebimentos/
 * Returns the full list of recebimentos for the user's franquia scope.
 */
import type { Recebimentos_GetrecebimentosRow } from './Recebimentos_GetrecebimentosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Recebimentos_GetrecebimentosResponseDados {
dados: Recebimentos_GetrecebimentosRow[]
}

export type Recebimentos_GetrecebimentosResponse = ApiResponse<Recebimentos_GetrecebimentosResponseDados>;

registerResponseContract('Recebimentos_GetrecebimentosResponse', {
  dados: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data_cadastro:      { type: 'string',  required: false },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_franquia_id:        { type: 'number',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      recebimento_valor_taxas:        { type: 'number',  required: false },
      recebimento_valor_liquido:      { type: 'number',  required: false },
      recebimento_provedor:           { type: 'string',  required: false },
      recebimento_origem:             { type: 'string',  required: true },
      recebimento_origem_id:          { type: 'number',  required: false },
      recebimento_registrado_por:     { type: 'string',  required: true },
      recebimento_registrado_por_id:  { type: 'string',  required: true },
      recebimento_id_externo:         { type: 'string',  required: false },
      recebimento_conta_externa_id:   { type: 'number',  required: false },
      recebimento_payroll_period_id:  { type: 'number',  required: false },
      recebimento_observacoes:        { type: 'string',  required: false },
      recebimento_data_disponivel:    { type: 'string',  required: false },
      recebimento_numero_parcelas:    { type: 'number',  required: false },
      recebimento_parcela_numero:     { type: 'number',  required: false },
      recebimento_parcela_de:         { type: 'number',  required: false },
    },
  },
})
